export const CONTENT_IDS = {
  LIVE_DEMO: 'live-demo',
  DESIGN: 'design',
  CODE: 'code',
};
